var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplorerRectangleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "440px",
    height: "153px",
    viewBox: "0 0 440 153",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.6834269%",
    y1: "48.6655082%",
    x2: "44.2884431%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373737",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-(2)",
    transform: "translate(-33.000000, -848.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(33.000000, 848.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#3C6384",
    opacity: 0.736441679,
    x: 0,
    y: 0,
    width: 440,
    height: 153,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82807026,113.207263 C3.74412653,112.837733 5.51137564,112.652968 8.12981757,112.652968 L431,112.652968 C435.418278,112.652968 439,116.23469 439,120.652968 L439,152.570776 L439,152.570776 C410.59368,136.171364 344.447535,130.545873 240.561564,135.694304 C142.17967,140.56996 90.8833653,139.459408 44.7525115,132.611872 C14.7235681,128.154459 11.2931795,123.182752 2.82807026,115.010965 C2.03105608,114.241568 1.45398585,113.761557 2.82807026,113.207263 Z",
    id: "Rectangle-Copy-7",
    fill: "url(#linearGradient-1)",
    opacity: 0.173782703,
    transform: "translate(220.500000, 132.611872) scale(1, -1) translate(-220.500000, -132.611872) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorerRectangleBg);
export default __webpack_public_path__ + "static/media/explorer-rectangle-bg.1e3015b2a1de399b6e02cae848dd44c0.svg";
export { ForwardRef as ReactComponent };